import React from 'react';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';

export function InsufficientAccessToReporting(props: Props) {
  const {t} = useTranslation();
  return (
    <Container>
      <Image src={"/assets/images/spacing-image.svg"} alt={""} />
      <HeadlineSmall style={{marginBottom: 12}}>{t('holidays.insufficient-access-title')}</HeadlineSmall>
      <BodyLarge>{t('holidays.insufficient-access-description')}</BodyLarge>
    </Container>
  )
}

interface Props {
}

const Container = styled.div`
  max-width: 500px;
  margin: 50px auto 200px auto;
`

const Image = styled.img`
  width: 100%;
  margin-bottom: 30px;
`
